import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: '/api/v1/', 
});

const token = "6f26b2404b8a4372b5db5e4e5d2856b4ef6a4c5366b80c6ba96d64a276f8b029";
axiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`;

export default axiosInstance;
